import React from 'react';

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-sage-400 border-t-transparent"></div>
        <p className="mt-4 text-gray-600">Loading Seen Place Hub...</p>
      </div>
    </div>
  );
}

export default Loading;